import { Component, OnInit, ChangeDetectorRef, effect, inject } from '@angular/core'

import { User } from '../core/types/User'

import { appNavLinks, siteIcon } from './configs'
import { LoadingStateService } from './services/app-loading-state.service'
import { AuthService } from '../core/keycloak-auth/public-api'
import { LoadingState } from './types/loading-state'
import { NavLinks } from './types/nav-link.model'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    private cdr = inject(ChangeDetectorRef)
    private loadingStateService = inject(LoadingStateService)
    private authService = inject(AuthService)

    readonly appVersion: string = window.env.version

    title = 'Turners and Growers Labour Reports'
    loadingState = LoadingState.Loading
    navLinks: NavLinks = []
    siteIcon = siteIcon
    appTitle = 'Labour Reports'
    currentTheme = localStorage.getItem('theme_choice') ? localStorage.getItem('theme_choice') : 'light-theme'

    currentUser: User

    constructor() {
        document.getElementsByTagName('body')[0].className = this.currentTheme
        this.currentUser = this.authService.currentUser()
        this.updateNavLinks()

        // React to authentication state changes
        effect(() => {
            this.currentUser = this.authService.currentUser()
            this.updateNavLinks()
            this.cdr.detectChanges()
        })
    }

    private updateNavLinks() {
        this.navLinks = []
        appNavLinks.forEach((link) => {
            for (const role of link.permissions) {
                if (this.currentUser.roles.includes(role)) {
                    this.navLinks.push(link)
                    break
                }
            }
        })
    }

    onLogout() {
        this.authService.logout()
    }

    ngOnInit() {
        this.loadingStateService.getLoadingState().subscribe((newState) => {
            this.loadingState = newState
            this.cdr.detectChanges()
        })
    }

    /**
     * Toggle between light and dark theme and persist selection
     */
    onThemeChange() {
        this.currentTheme = this.currentTheme === 'dark-theme' ? 'light-theme' : 'dark-theme'
        localStorage.setItem('theme_choice', this.currentTheme)
        document.getElementsByTagName('body')[0].className = this.currentTheme
    }
}
